import { watch } from "vue";

let appInstance = null;

export const setAppInstance = app => {
  appInstance = app;
};

export const getAuth0 = () => appInstance?.config?.globalProperties?.$auth0;

export const authGuard = async (to, from, next) => {
  const auth0 = getAuth0();

  if (!auth0) {
    return next({ path: "/landingpage", query: { redirectTo: to.fullPath } });
  }

  if (auth0.isLoading.value) {
    await new Promise(resolve => {
      const stop = watch(auth0.isLoading, loading => {
        if (!loading) {
          stop();
          resolve();
        }
      });
    });
  }

  if (auth0.isAuthenticated.value) {
    return next();
  }
  next({ path: "/landingpage", query: { redirectTo: to.fullPath } });
};
